import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import useGiphyObserver from 'components/Giphy/useGiphyObserver';
import { chatFontSettings } from 'utils/helpers';

import styles from './ChatMessageTypes.css';
import Gif from './components/Gif';


const AdminMessage = ({
  chatSettings,
  isDesktop,
  isTranslated,
  msg,
  showOriginalLanguage,
}) => {
  const [giphyObserver, isIntersecting] = useGiphyObserver();

  if (isDesktop) {
    return (
      <div
        ref={giphyObserver}
        className={`${styles.adminDesktopMsgWrapper} ${msg.isGif ? styles.gifBackground : ''}`}
      >
        <span
          className={styles.msgSender}
          style={chatFontSettings(isDesktop, chatSettings)}
        >
          {translate('strings.general.adminNameInChat')}:
        </span>
        {isTranslated && (
          <>
            <span
              className={styles.msgContent}
              style={chatFontSettings(isDesktop, chatSettings)}
            >
              <Gif
                alt={msg.translatedMessage}
                isIntersecting={isIntersecting}
                msg={msg}
              />
            </span>
            {showOriginalLanguage && !msg.isGif && (
              <div className={styles.italicOriginalMsg}>
                <span
                  className={styles.msgContent}
                  style={chatFontSettings(isDesktop, chatSettings)}
                >
                  {msg.message}
                </span>
              </div>
            )}
          </>
        )}
        {!isTranslated && (
          <span
            className={styles.msgContent}
            style={chatFontSettings(isDesktop, chatSettings)}
          >
            <Gif
              alt={msg.message}
              isIntersecting={isIntersecting}
              msg={msg}
            />
          </span>
        )}
      </div>
    );
  }

  return (
    <div
      ref={giphyObserver}
      className={`${styles.adminMsgWrapper} ${msg.isGif ? styles.gifBackground : ''}`}
    >
      <span
        className={styles.msgSender}
        style={chatFontSettings(isDesktop, chatSettings)}
      >
        {translate('strings.general.adminNameInChat')}:
      </span>
      {isTranslated && (
        <>
          <span
            className={styles.msgContent}
            style={chatFontSettings(isDesktop, chatSettings)}
          >
            <Gif
              alt={msg.translatedMessage}
              isIntersecting={isIntersecting}
              msg={msg}
            />
          </span>
          {showOriginalLanguage && !msg.isGif && (
            <div className={styles.italicOriginalMsg}>
              <span
                className={styles.msgContent}
                style={chatFontSettings(isDesktop, chatSettings)}
              >
                {msg.message}
              </span>
            </div>
          )}
        </>
      )}
      {!isTranslated && (
        <span
          className={styles.msgContent}
          style={chatFontSettings(isDesktop, chatSettings)}
        >
          <Gif
            alt={msg.message}
            isIntersecting={isIntersecting}
            msg={msg}
          />
        </span>
      )}
    </div>
  );
};

AdminMessage.propTypes = {
  chatSettings: PropTypes.object,
  isDesktop: PropTypes.bool,
  isTranslated: PropTypes.bool,
  msg: PropTypes.object,
  showOriginalLanguage: PropTypes.bool,
};

AdminMessage.defaultProps = {
  chatSettings: {},
  isDesktop: false,
  isTranslated: false,
  msg: {},
  showOriginalLanguage: false,
};

export default AdminMessage;
